import { render, staticRenderFns } from "./nationalProduction_page.vue?vue&type=template&id=587e04f0&scoped=true"
import script from "./nationalProduction_page.vue?vue&type=script&lang=js"
export * from "./nationalProduction_page.vue?vue&type=script&lang=js"
import style0 from "./nationalProduction_page.vue?vue&type=style&index=0&id=587e04f0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587e04f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('587e04f0')) {
      api.createRecord('587e04f0', component.options)
    } else {
      api.reload('587e04f0', component.options)
    }
    module.hot.accept("./nationalProduction_page.vue?vue&type=template&id=587e04f0&scoped=true", function () {
      api.rerender('587e04f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mng/nationalProduction_page.vue"
export default component.exports